// extracted by mini-css-extract-plugin
export default {"example":"IconTable-module__example___e8obW","table":"IconTable-module__table___caH_t"};